import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetAll } from 'store/store.constants';

export interface AuthState {
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    setAuth: (
      state,
      { payload }: PayloadAction<{ isAuthenticated: boolean }>,
    ) => {
      state.isAuthenticated = payload.isAuthenticated;
    },
  },
});

export const { setAuth } = authSlice.actions;

export default authSlice.reducer;
